import React from 'react'
import Profile1 from '../../Images/ProfileImages/Gauravimg.jpg'
import Profile2 from '../../Images/ProfileImages/Rutujimg.jpg'
import Profile3 from '../../Images/ProfileImages/Aniiimg.jpg'
import './CallBack.css'
import { useNavigate } from 'react-router-dom'
function CallBack() {
    const navigate = useNavigate();
    const NavigateFun = () => {
        navigate('/contact')
    }
    return (
        <>
            <div className="call-back-section">
                <div className="call-back-overlay">
                    <div className="call-back-content">
                        <h4>CALL BACK</h4>
                        <h2>Professional Quality Cleaning With Experts</h2>
                        <p>
                            Our team is dedicated to providing top-notch cleaning services, ensuring every detail is taken care of with precision and care.
                        </p>
                        <hr className="custom-divider" />
                        <div className="call-back-rating">
                            <div className="call-back-testimonials">
                                <img src={Profile1} alt="Profile 1" />
                                <img src={Profile2} alt="Profile 2" />
                                <img src={Profile3} alt="Profile 3" />
                            </div>
                            <div className="call-back-stars">
                                <i className="bi bi-star-fill"></i>
                                <i className="bi bi-star-fill"></i>
                                <i className="bi bi-star-fill"></i>
                                <i className="bi bi-star-fill"></i>
                                <i className="bi bi-star-half"></i>
                                <p>Rated 4.8 Out Of 5 By Our Clients</p>
                            </div>
                        </div>
                        <hr className="custom-divider" />
                        <div className="call-back-buttons">
                            <button className="contact-us-btn" onClick={() => NavigateFun()}>CONTACT US</button>
                            <div className="call-us">
                                <i className="bi bi-telephone-fill"></i>
                                <span>CALL US </span>
                                <p>+91 9008425897</p>
                            </div>

                        </div>

                    </div>
                    <div className="side-image">
                        {/* <img src={pointedman} alt="Call Back Image" /> */}
                    </div>
                </div>
            </div>
        </>
    )
}

export default CallBack
